module.exports = __webpack_public_path__ + "img/1.444fa772.jpg";